import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  navContent: {
    width: 350,
    "@media(max-width:600px)": {
      width: "80%",
    },
  },
  navDrawerHeader: {
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
}));
